import React from 'react';
import { PARTNER_CITIES } from '../../content';
import { portalCopy } from '../copy';
import type { PartnerBusiness } from '../types';

type ReadOnlyLocationBannerProps = {
  business: PartnerBusiness;
};

const ReadOnlyLocationBanner: React.FC<ReadOnlyLocationBannerProps> = ({ business }) => {
  const cityLabel = PARTNER_CITIES.find((city) => city.id === business.cityId)?.label ?? business.cityId;

  return (
    <div className="rounded-2xl border border-[rgba(74,33,71,0.1)] bg-[#fcf7fa] px-4 py-4">
      <p className="font-jakarta text-xs leading-relaxed text-[#5a3158]">
        {portalCopy.business.edit.locationSyncNote}
      </p>
      <dl className="mt-3 grid gap-2 font-jakarta text-sm sm:grid-cols-2">
        <div>
          <dt className="text-xs font-medium text-[#5a3158]">{portalCopy.wizard.basics.city}</dt>
          <dd className="font-semibold text-[#2a0f2a]">{cityLabel}</dd>
        </div>
        <div className="sm:col-span-1">
          <dt className="text-xs font-medium text-[#5a3158]">{portalCopy.wizard.basics.address}</dt>
          <dd className="font-semibold text-[#2a0f2a]">{business.address}</dd>
        </div>
      </dl>
    </div>
  );
};

export default ReadOnlyLocationBanner;
